import React from 'react';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatIsIt } from './components/WhatIsIt';
import { Testimonials } from './components/Testimonials';
import { MethodPhases } from './components/MethodPhases';
import { Bonuses } from './components/Bonuses';
import { KitProBonuses } from './components/KitProBonuses';
import { ComparisonTable } from './components/ComparisonTable';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Vision30Days } from './components/Vision30Days';
import { TwoOptions } from './components/TwoOptions';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen font-sans text-slate-800 bg-white selection:bg-success selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyBar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <PainPoints data-id="element-5" />
        <WhatIsIt data-id="element-6" />
        <Testimonials data-id="element-7" />
        <MethodPhases data-id="element-8" />
        <Bonuses data-id="element-9" />
        <KitProBonuses data-id="element-10" />
        <ComparisonTable data-id="element-11" />
        <Pricing data-id="element-12" />
        <FAQ data-id="element-13" />
        <Vision30Days data-id="element-14" />
        <TwoOptions data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <PurchaseNotification data-id="element-18" />
    </div>;
}